import { render, staticRenderFns } from "./PzFadForm.vue?vue&type=template&id=19f264cc"
import script from "./PzFadForm.vue?vue&type=script&lang=js"
export * from "./PzFadForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19f264cc')) {
      api.createRecord('19f264cc', component.options)
    } else {
      api.reload('19f264cc', component.options)
    }
    module.hot.accept("./PzFadForm.vue?vue&type=template&id=19f264cc", function () {
      api.rerender('19f264cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/commons/forms/DigitalSings/Fad/PzFadForm.vue"
export default component.exports